import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import {
    FaClock,
    FaMoneyBillWave,
    FaMapMarkerAlt,
    FaCalendarAlt,
    FaCheckCircle,
    FaUser,
    FaPhone,
    FaUsers
} from "react-icons/fa";

import { tours } from "../data/tours";
import "./Booking.css";


const Booking = () => {

    const { id } = useParams();
    const navigate = useNavigate();


    const tour = tours.find(
        item => item.id === Number(id)
    );


    const [form, setForm] = useState({
        name: "",
        phone: "",
        date: "",
        people: 1
    });


    const [loading, setLoading] = useState(false);


    if (!tour) {
        return (
            <div className="not-found">

                <h2>
                    Tur topilmadi 😕
                </h2>

                <button onClick={() => navigate("/tours")}>
                    ← Turlarga qaytish
                </button>

            </div>
        );
    }



    const handleChange = (e) => {

        setForm(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));

    };





    const sendTelegram = async () => {


        const BOT_TOKEN =
            "8640089731:AAEKDxEOzM-9m7Unk7OlxzJbBJulS4b5h7s";


        const CHAT_ID =
            "8419894563";



        const message = `

🌍 ADAM VOYAGE
━━━━━━━━━━━━━━━━━━

🧳 New Booking Request


🏝 Tour:
${tour.title}


👤 Client:
${form.name}


📞 Phone:
${form.phone}


📅 Travel date:
${form.date}


👥 Travelers:
${form.people}


━━━━━━━━━━━━━━━━━━

Website:
adamvoyage.com

        `;



        const response = await fetch(

            `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`,

            {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },


                body: JSON.stringify({

                    chat_id: CHAT_ID,

                    text: message

                })

            }

        );



        const data = await response.json();



        if (!data.ok) {

            throw new Error(
                data.description
            );

        }


        return true;

    };







    const handleSubmit = async (e) => {


        e.preventDefault();



        if (
            !form.name ||
            !form.phone ||
            !form.date
        ) {

            alert(
                "Please complete all fields"
            );

            return;

        }



        try {


            setLoading(true);


            await sendTelegram();



            alert(
                `✅ Thank you ${form.name}!

Your booking request has been received.

Adam Voyage team will contact you soon.

Welcome to Uzbekistan 🇺🇿`
            );



            navigate("/tours");



        } catch (error) {


            console.log(error);


            alert(
                "❌ Booking failed. Please try again."
            );


        } finally {


            setLoading(false);


        }


    };








    const sendWhatsApp = () => {


        const message = `

🧳 Adam Voyage Booking


Tour:
${tour.title}


Name:
${form.name}


Phone:
${form.phone}


Date:
${form.date}


Travelers:
${form.people}

        `;



        const url =
            `https://wa.me/998917077291?text=${encodeURIComponent(message)}`;



        window.open(
            url,
            "_blank"
        );


    };









    return (

        <div className="booking-page">


            <button

                className="back-btn"

                onClick={() => navigate(-1)}

            >

                ← Orqaga

            </button>





            <h1 className="booking-title">

                ✈️ Turni bron qilish

            </h1>



            <p className="booking-subtitle">

                Siz tanlagan premium sayohat

            </p>








            <div className="booking-card">


                <img

                    src={tour.gallery[0]}

                    alt={tour.title}

                />



                <div className="booking-card-info">


                    <span className="selected-tour">

                        <FaCheckCircle />

                        Tanlangan tur

                    </span>




                    <h3>

                        {tour.title}

                    </h3>




                    <p className="tour-description">

                        {tour.description}

                    </p>





                    <div className="tour-details-list">


                        <div>

                            <FaClock />

                            <section>

                                <strong>
                                    Davomiyligi
                                </strong>

                                <span>
                                    {tour.duration}
                                </span>

                            </section>

                        </div>




                        <div>

                            <FaMoneyBillWave />

                            <section>

                                <strong>
                                    Narxi
                                </strong>

                                <span>
                                    {tour.price}
                                </span>

                            </section>

                        </div>




                        <div>

                            <FaMapMarkerAlt />

                            <section>

                                <strong>
                                    Yo‘nalish
                                </strong>

                                <span>
                                    Xiva → Buxoro → Samarqand → Toshkent
                                </span>

                            </section>

                        </div>





                        <div>

                            <FaCalendarAlt />

                            <section>

                                <strong>
                                    Dastur
                                </strong>

                                <span>
                                    {tour.programme.length} kunlik sayohat
                                </span>

                            </section>

                        </div>


                    </div>


                </div>


            </div>








            <form

                className="booking-form"

                onSubmit={handleSubmit}

            >



                <div className="input-group">

                    <FaUser />

                    <input

                        name="name"

                        placeholder=" "

                        value={form.name}

                        onChange={handleChange}

                    />

                    <label>
                        Ismingiz
                    </label>


                </div>





                <div className="input-group">


                    <FaPhone />


                    <input

                        name="phone"

                        placeholder=" "

                        value={form.phone}

                        onChange={handleChange}

                    />


                    <label>
                        Telefon raqam
                    </label>


                </div>






                <div className="input-group">


                    <FaCalendarAlt />


                    <input

                        type="date"

                        name="date"

                        value={form.date}

                        onChange={handleChange}

                    />


                    <label>
                        Sayohat sanasi
                    </label>


                </div>







                <div className="input-group">


                    <FaUsers />


                    <input

                        type="number"

                        name="people"

                        min="1"

                        value={form.people}

                        onChange={handleChange}

                    />


                    <label>
                        Odamlar soni
                    </label>


                </div>





                <button

                    className="submit-btn"

                    disabled={loading}

                >

                    {
                        loading
                            ?
                            "Yuborilmoqda..."
                            :
                            "Premium Booking"
                    }


                </button>


            </form>





            <button

                className="whatsapp-btn"

                onClick={sendWhatsApp}

            >

                💬 WhatsApp orqali bog‘lanish

            </button>



        </div>

    );

};


export default Booking;